export const Divider = () => {
  return <hr className="border-blue-100" />;
};
